import ContentBox from 'components/ContentBox'
import Page from 'components/Page'
import PageEditButton from 'components/Page/Page.EditButton'
import PageRecommended from 'components/Page/Page.Recommended'
import PageShareButtons from 'components/Page/Page.ShareButtons'
import PageSupplementary from 'components/Page/Page.Supplementary'
import { View } from 'components/View'
import CommunityPosts from 'containers/CommunityPosts'
import RecommendedItem from 'containers/RecommendedItem'
import {
  PRODUCT_MODEL_CLASS_NAME,
  PRODUCT_MODEL_DATA,
  PRODUCT_MODEL_KEY
} from 'models/daos/product/constants'
import { getOptionsProductUtil } from 'models/daos/product/utils/get-options'
import { getFirstProductQuantityInStockProductUtil } from 'models/daos/product/utils'
import { isPosterProductUtil } from 'models/daos/product/utils/is-poster'
import { isEditableUserUtil } from 'models/daos/user/utils'
import { getSharePropsModelUtil } from 'models/utils/get-share-props'
import { addProductCartAction } from 'modules/cart/actions'
import {
  getNameCurrencySelector,
  getValueCurrencySelector
} from 'modules/currencies/selectors'
import openModalAction from 'modules/modal/actions/open'
import { MODAL_ID } from 'modules/modal/constants/index.cjs'
import { MOTIVATION_DOMAIN } from 'modules/motivation/constants'
import { isParsingCompletedSelector } from 'modules/parser/selectors'
import { PRODUCTS_DOMAIN } from 'modules/products/constants'
import {
  getProductQuantitiesProductsSelector,
  getPromoCodesProductSelector
} from 'modules/products/selectors'
import loadInstance from 'modules/redux/decorators/loadInstance'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import { getRelativeUrlReduxUtil } from 'modules/redux/utils/get-url'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { hasErrorReduxUtil } from 'modules/redux/utils/legacy/has-error'
import { isLoadedReduxUtil } from 'modules/redux/utils/legacy/is-loaded'
import {
  ROUTE,
  ROUTE_PATH
} from 'modules/routes/constants/index.cjs'
import { getInstanceRecommendedSectionSelector } from 'modules/section/selectors'
import getInstanceSectionSelector from 'modules/section/selectors/get-instance'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import getCurrentUserSelector from 'modules/users/selectors/get-current'
import {
  getObjectUtil,
  isEqualUtil,
  logUtil,
  toSlugStringUtil
} from 'packages/src'
import ProductDetails from 'pages/Product/Details'
import ProductGallery from 'pages/Product/Gallery'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { getStrFromSlugStringUtil } from 'utils/string/get-str-from-slug'
import './index.scss'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import isDifferentLocationWithoutQueryLocationUtil from 'modules/router/utils/is-different-location-without-query/index.js'
import loadInstanceSectionAction from 'modules/section/actions/index.js'

const queryString = require('query-string')

const ANALYTIC_EVENT_PREFIX = 'PRODUCT'

@loadInstance
class ProductPage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedProductQuantityId: this.getFirstProductQuantityInStockId(props)
    }
    this.handleChangeSelectedIndex = this.handleChangeSelectedIndex.bind(this)
    this.handleChangeSelectedOption = this.handleChangeSelectedOption.bind(this)
    logUtil('ProductPage').debug('props=', props)
    logUtil('ProductPage').debug('state=', this.state)
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (this.state !== nextState) {
      return !isEqualUtil(this.state, nextState)
    }
    return true
  }

  componentDidMount () {
    this.loadMotivationFromOption()
  }

  componentDidUpdate (prevProps, prevState) {
    const prevLocation = prevProps.location
    const location = this.props.location

    // If it's a different location,
    // load the new data and set the new selected Product id
    if (
      this.hasInstance() &&
      isDifferentLocationWithoutQueryLocationUtil(prevLocation, location)
    ) {
      this.setCurrentState()
    } else if (
      this.hasInstance() &&
      !this.props.motivationPosterFromOption &&
      !this.state.selectedProductQuantityId &&
      this.getFirstProductQuantityInStock()
    ) {
      this.setCurrentState()
    } else if (
      this.getFirstProductQuantityInStockId(prevProps) !==
      this.getFirstProductQuantityInStockId(this.props)
    ) {
      this.setCurrentState()
    }

    // If the user just signed in,
    // add the `Product` to the `Cart`
    if (
      this.state.productQuantityIdToAdd &&
      !prevProps.currentUser &&
      this.props.currentUser
    ) {
      this.handleAfterSignIn()
    }
  }

  hasInstance (props = this.props) {
    const { instance } = props
    return (
      instance && instance.className ===
      PRODUCT_MODEL_CLASS_NAME && isLoadedReduxUtil(instance)
    )
  }

  getSelectedOrDefaultOption () {
    let option = this.getSelectedOption()
    if (!option) {
      option = getObjectUtil(getValueReduxUtil(
        this.props.instance,
        PRODUCT_MODEL_KEY.DATA
      ), 'option')
    }

    return option
  }

  getSelectedOption () {
    const query = this.getQueryParams()
    const { option } = query
    if (!option) {
      return
    }

    return getOptionsProductUtil(this.props.instance)
      .find(o => toSlugStringUtil(o) === option)
  }

  getSelectedOptionOrMotivation () {
    const motivationPosterFromOption = (
      this.getLoadedMotivationPosterFromOption()
    )
    if (motivationPosterFromOption) {
      return getValueReduxUtil(motivationPosterFromOption, 'slug')
    }
    return this.state.selectedOption
  }

  getFirstProductQuantityInStock (props = this.props) {
    return (
      getFirstProductQuantityInStockProductUtil(props.productQuantities)
    )
  }

  getFirstProductQuantityInStockId (props = this.props) {
    return (
      getIdReduxUtil(this.getFirstProductQuantityInStock(props))
    )
  }

  getCurrentState () {
    const selectedOption = this.getSelectedOrDefaultOption()
    return {
      selectedProductQuantityId: this.getFirstProductQuantityInStockId(),
      productQuantityIdToAdd: null,
      selectedOption
    }
  }

  setCurrentState () {
    const currentState = this.getCurrentState()
    logUtil('ProductPage#setCurrentState').debug('currentState=', currentState)
    logUtil('ProductPage#setCurrentState').debug('props=', this.props)
    this.setState(currentState)
  }

  getLoadedMotivationPosterFromOption () {
    const { motivationPosterFromOption } = this.props
    if (!isLoadedReduxUtil(motivationPosterFromOption)) {
      return
    }
    return motivationPosterFromOption
  }

  getSelectedImageIndex () {
    let { selectedOption } = this.state
    const motivationPosterFromOption = (
      this.getLoadedMotivationPosterFromOption()
    )

    if (!selectedOption && !motivationPosterFromOption) {
      return 0
    }

    const options = getOptionsProductUtil(this.props.instance)
    if (motivationPosterFromOption) {
      selectedOption = motivationPosterFromOption
      options.push(motivationPosterFromOption)
    }

    const selectedImageIndex = options.findIndex((option) => option ===
      selectedOption)

    return selectedImageIndex === -1
      ? 0
      : selectedImageIndex
  }

  getQueryParams () {
    return queryString.parse(this.props.location.search)
  }

  async loadMotivationFromOption () {
    const query = this.getQueryParams()
    const selectedOption = this.getSelectedOption()
    const { option } = query
    const { motivationPosterFromOption } = this.props
    const debugProps = {
      option,
      selectedOption,
      motivationPosterFromOption
    }
    logUtil('loadMotivationFromOption').debug('debugProps=', debugProps)

    if (!option || selectedOption || motivationPosterFromOption) {
      logUtil('loadMotivationFromOption').debug('[noop]')
      this.setCurrentState()
      return
    }

    try {
      await this.props.dispatch(
        loadInstanceSectionAction({
          route: ROUTE[ROUTE_PATH.MOTIVATION_BY_CATEGORY_OR_SLUG],
          match: {
            params: {
              slug: option
            }
          }
        })
      )
    } catch (error) {
      console.error('[loadMotivationFromOption] failed: ', error)
    }
  }

  handleChangeSelectedOption (option) {
    this.setState({
      selectedOption: option
    })
  }

  handleChangeSelectedIndex (index) {
    const options = getOptionsProductUtil(this.props.instance)
    this.setState({
      selectedOption: options[index]
    })
  }

  handleAfterSignIn () {
    const {
      productQuantityIdToAdd,
      selectedOption
    } = this.state
    this.addToCart(productQuantityIdToAdd, selectedOption)
      .then(() => this.props.dispatch(openModalAction(MODAL_ID.CHECKOUT)))
  }

  handleChangeProductQuantity (selectedProductQuantity) {
    this.setState({
      selectedProductQuantityId: selectedProductQuantity.data.id
    })
  }

  handleClickAddToCart (selectedOption) {
    if (this.props.currentUser) {
      this.addToCart(this.state.selectedProductQuantityId, selectedOption)
      return
    }
    // If there is no user signed in,
    // show the signin modal
    // then add the `Product` to the `Cart`
    this.props.dispatch(openModalAction(MODAL_ID.SIGNIN, {
      isAddingProductToCart: true
    }))
    // add the `Product` to the cart
    this.setState({
      productQuantityIdToAdd: this.state.selectedProductQuantityId,
      selectedOption
    })
  }

  handleClickChangeCurrency () {
    this.props.dispatch(openModalAction(MODAL_ID.CURRENCIES))
  }

  addToCart (productQuantityId, selectedOption) {
    return this.props.dispatch(addProductCartAction(
      this.props.instance,
      productQuantityId,
      selectedOption
    ))
  }

  getDiscountPercentage () {
    const { promoCodes } = this.props
    if (!promoCodes.length) {
      return 0
    }
    return promoCodes[0].data.value * 100
  }

  getPrice () {
    return (
      this.props.instance.data.price * this.props.currencyValue
    )
  }

  getDiscountPrice () {
    const { promoCodes } = this.props
    if (!promoCodes.length) {
      return 0
    }
    const price = this.getPrice()
    return price -
      (
        promoCodes[0].data.value * price
      )
  }

  getProductData () {
    const data = getValueReduxUtil(this.props.instance, 'data')
    const motivationPosterFromOption = (
      this.getLoadedMotivationPosterFromOption()
    )

    if (!motivationPosterFromOption) {
      return data
    }

    return {
      ...data,
      [PRODUCT_MODEL_DATA.IMAGE10]: getValueReduxUtil(
        motivationPosterFromOption,
        'img'
      )
    }
  }

  renderCommunityPosts () {
    if (isPosterProductUtil(this.props.instance)) {
      return
    }
    const slug = (
      getValueReduxUtil(this.props.instance, PRODUCT_MODEL_KEY.SLUG) || ''
    )
    const query = getStrFromSlugStringUtil(slug)
    return (
      <CommunityPosts
        location={this.props.location}
        match={this.props.match}
        query={query}
        route={this.props.route}
        type={CommunityPosts.TYPE.PRODUCT}
      />
    )
  }

  renderContent () {
    const isSmallScreen = this.props.isSmallScreen
    return (
      <View
        style={{
          flexDirection: isSmallScreen
            ? View.DIRECTION.COLUMN
            : View.DIRECTION.ROW,
          alignItems: View.ALIGN.START
        }}
      >
        {this.renderGallery()}
        {this.renderDetails()}
      </View>
    )
  }

  renderDetails () {
    const props = {
      content: this.props.instance.data.content,
      currency: this.props.currencyName,
      discountPrice: this.getDiscountPrice(),
      isLoadingProductQuantities: !this.props.isParsingCompleted,
      name: this.props.instance.data.name,
      onChangeProductQuantity: this.handleChangeProductQuantity.bind(this),
      onClickAddToCart: this.handleClickAddToCart.bind(this),
      onClickChangeCurrency: this.handleClickChangeCurrency.bind(this),
      price: this.getPrice(),
      productQuantities: this.props.productQuantities,
      selectedProductQuantityId: this.state.selectedProductQuantityId,
      type: this.props.instance.data.type,
      instance: this.props.instance,
      selectedOption: this.getSelectedOptionOrMotivation(),
      onChangeSelectedOption: this.handleChangeSelectedOption
    }
    return <ProductDetails {...props} />
  }

  renderEditButton () {
    if (!isEditableUserUtil(this.props.currentUser, this.props.instance)) {
      return
    }
    return <PageEditButton url={getRelativeUrlReduxUtil(this.props.instance)} />
  }

  renderGallery () {
    const {
      img,
      name,
      title
    } = this.props.instance.data

    const props = {
      data: this.getProductData(),
      image: img,
      name,
      title,
      discountPercentage: this.getDiscountPercentage(),
      onChangeSelectedIndex: this.handleChangeSelectedIndex,
      isLimitedEdition: !!getValueReduxUtil(
        this.props.instance,
        PRODUCT_MODEL_KEY.LIMITED_AT
      ),
      selectedImageIndex: this.getSelectedImageIndex()
    }

    const isSmallScreen = this.props.isSmallScreen
    return (
      <div
        style={{
          marginRight: isSmallScreen
            ? null
            : STYLES_MARGIN.BIG,
          marginBottom: isSmallScreen
            ? STYLES_MARGIN.BIG
            : null,
          width: '100%',
          flex: 1
        }}
      >
        <ProductGallery {...props} />
      </div>
    )
  }

  renderRecommended () {
    const { recommended } = this.props
    if (!recommended || !recommended.length) {
      return
    }
    return (
      <PageRecommended>
        {recommended.map((instance, index) => (
          <RecommendedItem
            currentUser={this.props.currentUser}
            key={index}
            instance={instance}
            analyticEventPrefix={ANALYTIC_EVENT_PREFIX}
          />
        ))}
      </PageRecommended>
    )
  }

  renderSupplementary () {
    return (
      <PageSupplementary>
        {this.renderCommunityPosts()}
        {this.renderRecommended()}
      </PageSupplementary>
    )
  }

  renderProduct () {
    if (!this.props.instance) {
      return
    }
    return (
      <div>
        <ContentBox>
          <div className='product'>
            {this.renderContent()}
            {this.renderShare()}
          </div>
        </ContentBox>
        {this.renderSupplementary()}
      </div>
    )
  }

  renderShare () {
    const props = getSharePropsModelUtil(this.props.instance)
    return <PageShareButtons {...props} />
  }

  render () {
    if (!this.hasInstance()) {
      return <div />
    }
    return (
      <Page
        value={this.props.instance}
        style={{}}
      >
        {this.renderEditButton()}
        {this.renderProduct()}
        {/* <LoadCurrencies /> */}
      </Page>
    )
  }
}

ProductPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
  instance: PropTypes.object,
  motivationPosterFromOption: PropTypes.object,
  promoCodes: PropTypes.arrayOf(PropTypes.object),
  recommended: PropTypes.arrayOf(PropTypes.object),
  productQuantities: PropTypes.arrayOf(PropTypes.object),
  currencyValue: PropTypes.number.isRequired,
  currencyName: PropTypes.string.isRequired,
  isParsingCompleted: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object,
  route: PropTypes.object.isRequired,
  isSmallScreen: PropTypes.bool
}

const getMotivationFromOption = (state, props) => {
  if (!props.location) {
    return
  }
  const query = queryString.parse(props.location.search)
  const { option } = query
  if (!option) {
    return
  }
  const instance = getObjectUtil(state, `${MOTIVATION_DOMAIN}.data.${option}`)
  if (hasErrorReduxUtil(instance)) {
    return
  }
  return instance
}

const select = () => createSelector(
  getValueCurrencySelector(),
  getNameCurrencySelector(),
  getCurrentUserSelector(),
  getInstanceSectionSelector(),
  getProductQuantitiesProductsSelector(),
  getPromoCodesProductSelector(),
  getInstanceRecommendedSectionSelector(PRODUCTS_DOMAIN),
  isParsingCompletedSelector(),
  getMotivationFromOption,
  isSmallScreenViewportSelect,
  (
    currencyValue,
    currencyName,
    currentUser,
    instance,
    productQuantities,
    promoCodes,
    recommended,
    isParsingCompleted,
    motivationPosterFromOption,
    isSmallScreen
  ) => (
    {
      currencyValue,
      currencyName,
      currentUser,
      isParsingCompleted,
      instance,
      productQuantities,
      promoCodes,
      recommended,
      motivationPosterFromOption,
      isSmallScreen
    }
  )
)

const Product = connect(select)(ProductPage)

export default Product
